import axios, { AxiosResponse } from 'axios';
import { IRequestData, IResponseDataItem } from './find-liquidated-taxpayer.type';

export const url = '/services/isnaportalsync/open-api/find-liquidated-taxpayer';

type Options = {
    captchaSession?: string;
    skipErrorNotification?: boolean;
};

export const getLiquidatedTaxpayerInfo = (
    request: IRequestData,
    options?: Options
): Promise<AxiosResponse<IResponseDataItem>> => {
    return axios.get(`${url}`, {
        params: request,
        headers: {
            'session-expiration': options?.captchaSession,
        },
        skipErrorNotification: options?.skipErrorNotification,
    });
};

export const downloadExcel = (request: any): Promise<AxiosResponse> => {
    return axios.get(url, {
        params: { ...request, excel: true },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};
